import Documents from "@/modules/documents/documents-layout"
import Archive from "@/modules/documents/archive-layout"
import Folders from "@/modules/documents/folders-layout"
import DocumentsRouter from "@/modules/documents/documents-router"

const DocumentRouter = {
	path: "/documents",
	// name e il name del primo figlio devono essre uguali per essere caricati
	name: "documents",
	component: DocumentsRouter,
	props: true,
	children: [
		{
			path: "folders",
			name: "documents.folders",
			component: Folders,
			props: true
		},
		{
			path: "doc-archive",
			name: "documents.doc-archive",
			component: Archive,
			props: true
		},
		{
			path: "folders/:folder_id",
			name: "documents.folders.folder_id",
			component: Documents,
			props: true
		},
		{
			path: "all-docs",
			name: "documents.all-docs",
			component: Documents,
			props: true
		},
		{
			path: "all-docs/:document_id",
			name: "documents.all-docs.document_id",
			component: Documents,
			props: true
		},
		{
			path: "",
			name: "documents.all-docs",
			component: Documents,
			props: true
		}
	]
}

export default DocumentRouter
